import React, { useState, useEffect, useRef } from "react";
import { Globe2, Check } from "lucide-react";
import { LANGS, LANG_FLAGS, LANG_LABELS, useAffLang } from "./i18n";

export default function LangPicker({ compact = false }) {
  const lang = useAffLang((s) => s.lang);
  const setLang = useAffLang((s) => s.setLang);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="aff-lang-picker"
        title="Language"
        className={`inline-flex items-center gap-1.5 text-muted-foreground hover:text-foreground border border-border hover:border-foreground/40 transition-colors ${
          compact ? "px-2 h-7" : "px-2.5 h-8"
        }`}
      >
        <Globe2 className="w-3.5 h-3.5" />
        <span className="text-xs">{LANG_FLAGS[lang]}</span>
      </button>
      {open && (
        <div
          className="absolute right-0 top-full mt-1 z-50 bg-background border border-border min-w-[160px] py-1 shadow-lg"
          data-testid="aff-lang-menu"
        >
          {LANGS.map((code) => (
            <button
              key={code}
              type="button"
              onClick={() => {
                setLang(code);
                setOpen(false);
              }}
              data-testid={`aff-lang-${code}`}
              className={`w-full flex items-center gap-2 px-3 py-1.5 text-xs text-left hover:bg-secondary/50 transition-colors ${
                lang === code ? "text-foreground" : "text-muted-foreground"
              }`}
            >
              <span>{LANG_FLAGS[code]}</span>
              <span className="flex-1">{LANG_LABELS[code]}</span>
              {lang === code && <Check className="w-3 h-3" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
